import type { MaybeRefOrGetter } from 'vue';

// Whether the active customer owes unpaid invoices; with a currency, only when they are in that currency.
export default (currencyCode?: MaybeRefOrGetter<string | null | undefined>) => {
  const authStore = useAuthStore();
  const paymentStore = usePaymentStore();
  const { balanceMigrated } = useBalanceMigrated();

  const hasUnpaidInvoices = computed(() => {
    const currency = toValue(currencyCode);
    return (
      paymentStore.hasUnpaidInvoices &&
      (currency == null ||
        currency === authStore.activeCustomer?.wallet?.currencyCode)
    );
  });

  return { hasUnpaidInvoices, balanceMigrated };
};
